import React from "react";
import { Redirect, Route } from "react-router-dom";
import { TOKEN_NAME } from "CONSTANTS";
import { connect } from "react-redux";

const AdminRoute = ({ component, exact, path, computedMatch, location, ...otherProps, isAdmin }) => {
  if (!localStorage[TOKEN_NAME])
    return <Redirect to={{ pathname: `/login`, state: { next: { ...location } } }} />;
    if(!isAdmin) {
      return (
      <h4 className="container">Brak uprawnień
        <p><small>Nie masz uprawnień do wyświetlenia tej strony. Aby uzyskać dostęp poproś administrację o nadanie uprawnień administratora.</small></p>
      </h4>
      );
    }
  return <Route path={path} exact={exact} component={component} />;
};

const mapState = state => ({
  isAdmin: state.auth.user.is_admin,
});

export default connect(mapState)(AdminRoute);



// WEBPACK FOOTER //
// ./src/components/routes/AdminRoute.jsx